import styles from "./modal.module.css";
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import { UIIconButton } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";
import { motion, AnimatePresence } from "framer-motion";

interface ModalProps {
  children: React.ReactNode;
  showCloseButton?: boolean;
  onClose: () => void;
  isOpen: boolean;
}

export const Modal = ({
  children,
  showCloseButton = true,
  onClose,
  isOpen,
}: ModalProps) => {
  const [isBrowser, setIsBrowser] = useState(false);

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  const modalContent = (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.overlay}
          onClick={onClose}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className={styles.modal}
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.3 }}
          >
            {showCloseButton && (
              <UIIconButton
                className={styles.close}
                iconName="REMOVE"
                onClick={onClose}
              />
            )}
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  if (isBrowser) {
    return createPortal(modalContent, document.body);
  } else {
    return null;
  }
};
